import * as Yup from 'yup';
import { ASSISTANT_TYPES } from '../../../../../../constants';

export const generationFormValidation = () => {
  return Yup.object().shape({
    byPass: Yup.string(),
    focusOn: Yup.string(),
    fileText: Yup.string(),
    url: Yup.string().when('assistant', ([assistant], schema) => {
      if (assistant.type === ASSISTANT_TYPES.TEXT) {
        return schema.required('required');
      } else {
        return schema.nullable();
      }
    }),
    assistant: Yup.mixed().required('required'),
    docs: Yup.mixed().nullable(),
  });
};
